import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../AuthContext'

const Header = () => {
  const { user, logout } = useAuth()
  return (
    <header>
      <div className="header-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <ul className="header-contact">
                <li>
                  <span>Call :</span>
                  (+91) 9136431685
                </li>
                <li>
                  <span className='test'>Email :</span>
                  info@monarchinstitute.in
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="header-right float-right">
                <div className="header-socials">
                  <ul>
                    <li><a target='_blank' rel='noreferrer' href="https://www.facebook.com/people/Monarch-Institute/61567960886635/"><i className="fab fa-facebook-f"></i></a></li>
                    <li><a target='_blank' rel='noreferrer' href="https://www.youtube.com/@monarchinstitute-neet"><i className="fab fa-youtube"></i></a></li>
                    <li><a target='_blank' rel='noreferrer' href="https://www.linkedin.com/in/monarch-institute-61b591349/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BrYWxCqO9RbmDOJaAZ20TwQ%3D%3D"><i className="fab fa-linkedin"></i></a></li>
                  </ul>
                </div>
                {
                  user ? '' :
                    <div className="header-btn">
                      <Link to='/login' className="btn btn-main btn-small py-2 mt-1 px-3 mb-1 mr-1" style={{ backgroundColor: '#8000d5', borderColor: '#8000d5', borderRadius: '3px' }}><i className="fa fa-user mr-2"></i>Login</Link>
                      <Link to='/register' className="btn btn-main btn-small py-2 px-3 mt-1 mb-1" style={{ backgroundColor: '#8000d5', borderColor: '#8000d5', borderRadius: '3px' }}><i className="fa fa-user mr-2"></i>Register</Link>
                    </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="site-navigation main_menu py-0" id="mainmenu-area">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <Link to='/' className="navbar-brand">
              <img src="/assets/images/monoarclogo.jpeg" alt="Edutim" className="img-fluid" width={'250px'} />
            </Link>



            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
              <span className="fa fa-bars"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarMenu">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item dropdown">
                  <Link to='/' className="nav-link" id="navbar3" >
                    Home
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link to='/about-us' className="nav-link js-scroll-trigger">
                    About us
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link className="nav-link dropdown-toggle" href="#" id="navbar3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Courses<i className="fa fa-angle-down"></i>
                  </Link>
                  <div className="dropdown-menu" aria-labelledby="navbar3">
                    <Link className="dropdown-item " to='/course/topic-wise-practice'>
                      Topic Wise Practice
                    </Link>
                    <Link className="dropdown-item " to='/course/neet-flexi-test'>
                      NEET Flexi Test
                    </Link>
                    <Link className="dropdown-item " to='/course/neet-pyq-practice'>
                      NEET PYQ Practice
                    </Link>
                    <Link className="dropdown-item " to='/courses/Class XI'>
                      Class XI
                    </Link>
                    <Link className="dropdown-item " to='/courses/Class XII'>
                      Class XII
                    </Link>

                    <Link className="dropdown-item " to='/courses/Class XII Passed'>
                      Class XII Passed
                    </Link>
                  </div>
                </li>
                <li className="nav-item ">
                  <Link to='/blogs' className="nav-link js-scroll-trigger">
                    Blogs
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link className="nav-link dropdown-toggle" href="#" id="navbar3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Student Section<i className="fa fa-angle-down"></i>
                  </Link>
                  <div className="dropdown-menu" aria-labelledby="navbar3">
                    <Link className="dropdown-item " to='/testimonials'>
                      Student Testimonials
                    </Link>
                    <Link className="dropdown-item " to='/gallery'>
                      Gallery
                    </Link>
                    <Link className="dropdown-item " to='/mock-test'>
                      Free Mock Test
                    </Link>
                  </div>
                </li>
                {/* <li className="nav-item dropdown">
                  <Link className="nav-link dropdown-toggle" href="#" id="navbar3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Materials<i className="fa fa-angle-down"></i>
                  </Link>
                  <div className="dropdown-menu" aria-labelledby="navbar3">
                    <Link className="dropdown-item " to='/courses/Class XI'>
                      Class XI
                    </Link>
                    <Link className="dropdown-item " to='/materials/Class XII'>
                      Class XII
                    </Link>

                    <Link className="dropdown-item " to='/materials/Class XII Passed'>
                      Class XII Passed
                    </Link>
                  </div>
                </li> */}
                {
                  user ?
                    <li className="nav-item dropdown">
                      <Link className="nav-link dropdown-toggle" href="#" id="navbar3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Welcome, {user.name}<i className="fa fa-angle-down"></i>
                      </Link>
                      <div className="dropdown-menu" aria-labelledby="navbar3">
                        {
                          user.role === 'student' ?
                            <Link className="dropdown-item " to={`/student/${user.email}`}>
                              Profile
                            </Link> :
                            <Link className="dropdown-item " to={`/admin/dashboard`}>
                              Dashboard
                            </Link>
                        }
                        <span className="dropdown-item fs-6" onClick={logout}>
                          Logout
                        </span>
                      </div>
                    </li> : ''
                }
                <li className="nav-item ">
                  <Link to='/contact-us' className="nav-link">
                    Contact
                  </Link>
                </li>
              </ul>


            </div>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header
